'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Rhino(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 18 19' }, props),
    React.createElement(
      'title',
      null,
      '\u6A21\u677F\u7BA1\u7406 copy'
    ),
    React.createElement(
      'desc',
      null,
      'Created with Sketch.'
    ),
    React.createElement(
      'g',
      { id: 'Symbols', stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
      React.createElement(
        'g',
        { id: '\u5168\u5C40/\u5DE6\u4FA7\u680F/\u6D45\u8272', transform: 'translate(-17.000000, -349.000000)' },
        React.createElement(
          'g',
          { id: 'icon/\u901A\u7528\u7B26\u53F7/\u6A21\u677F-copy', transform: 'translate(16.000000, 348.000000)' },
          React.createElement('path', { d: 'M3.75,4.89330893 L3.75,5 L7.5,5 L7.5,5.1298815 C7.5,4.02261602 8.40161769,3.125 9.4983112,3.125 L16.7516888,3.125 C17.8553256,3.125 18.75,4.0188998 18.75,5.1298815 L18.75,6.1201185 C18.75,7.22738398 17.8483823,8.125 16.7516888,8.125 L9.4983112,8.125 C8.3946744,8.125 7.5,7.2311002 7.5,6.1201185 L7.5,6.25 L3.75,6.25 L3.75,10.625 L7.5,10.625 L7.5,9.99881335 C7.5,9.30911278 8.05788925,8.75 8.74693081,8.75 L17.5030692,8.75 C18.1917301,8.75 18.75,9.30419147 18.75,9.99881335 L18.75,12.5011867 C18.75,13.1908872 18.1921108,13.75 17.5030692,13.75 L8.74693081,13.75 C8.05826994,13.75 7.5,13.1958085 7.5,12.5011867 L7.5,11.875 L3.75,11.875 L3.75,15.2605961 C3.75,15.8128808 4.19771525,16.2605961 4.75,16.2605961 L7.50350474,16.2605961 C7.56547348,15.2088613 8.44128222,14.375 9.4983112,14.375 L16.7516888,14.375 C17.8553256,14.375 18.75,15.2688998 18.75,16.3798815 L18.75,17.3701185 C18.75,18.477384 17.8483823,19.375 16.7516888,19.375 L9.4983112,19.375 C8.43534114,19.375 7.56621754,18.5457632 7.50360998,17.4920126 L4.5,17.4920126 C3.3954305,17.4920126 2.5,16.5965821 2.5,15.4920126 L2.5,4.89330893 C1.77175477,4.63591118 1.25,3.94138677 1.25,3.125 C1.25,2.08946609 2.08946609,1.25 3.125,1.25 C4.16053391,1.25 5,2.08946609 5,3.125 C5,3.94138677 4.47824523,4.63591118 3.75,4.89330893 Z M8.75,10.6308556 L8.75,11.8691444 C8.75,12.2229043 9.03173755,12.5 9.37927842,12.5 L16.8707216,12.5 C17.218782,12.5 17.5,12.2175563 17.5,11.8691444 L17.5,10.6308556 C17.5,10.2770957 17.2182625,10 16.8707216,10 L9.37927842,10 C9.03121797,10 8.75,10.2824437 8.75,10.6308556 Z M8.75,5.37744075 L8.75,5.87255925 C8.75,6.4280501 9.19938803,6.875 9.75373626,6.875 L16.4962637,6.875 C17.0540567,6.875 17.5,6.42619199 17.5,5.87255925 L17.5,5.37744075 C17.5,4.8219499 17.050612,4.375 16.4962637,4.375 L9.75373626,4.375 C9.19594333,4.375 8.75,4.82380801 8.75,5.37744075 Z M8.75,16.6274408 L8.75,17.1225592 C8.75,17.6780501 9.19938803,18.125 9.75373626,18.125 L16.4962637,18.125 C17.0540567,18.125 17.5,17.676192 17.5,17.1225592 L17.5,16.6274408 C17.5,16.0719499 17.050612,15.625 16.4962637,15.625 L9.75373626,15.625 C9.19594333,15.625 8.75,16.073808 8.75,16.6274408 Z', id: 'Combined-Shape' })
        )
      )
    )
  );
}
Rhino.displayName = 'Rhino';

module.exports = Rhino;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/rhino.js
// module id = 226
// module chunks = 0